import { BigNum } from '@drift-labs/sdk';
import React from 'react';
import { compareDriftProps } from 'src/utils/compareProps';
import { UIOrderType } from '@drift/common';
import TpSlOrderFormInputs from 'src/components/TradeForm/TpSlOrderForm/TpSlOrderFormInputs';
import useTpSlOrderForm from 'src/components/TradeForm/TpSlOrderForm/hooks/useTpSlOrderForm';
import { SaveTpSlOrdersCallback } from 'src/components/TradeForm/TpSlOrderForm/types';
import TpSlOrderFormMessage from 'src/components/TradeForm/TpSlOrderForm/TpSlOrderFormMessage';

interface Props {
	direction: 'long' | 'short';
	entryPrice: BigNum;
	entrySize: BigNum;
	saveOrdersCallback: SaveTpSlOrdersCallback;
	orderType: UIOrderType;
	savedTakeProfitPrice: BigNum | null | undefined;
	savedStopLossPrice: BigNum | null | undefined;
}

const TpSlOrderForm = ({
	direction,
	entryPrice,
	entrySize,
	saveOrdersCallback,
	orderType,
	savedTakeProfitPrice,
	savedStopLossPrice,
}: Props) => {
	const {
		takeProfitPriceStringValue,
		takeProfitPercentStringValue,
		takeProfitPrice,
		takeProfitInvalid,
		takeProfitInvalidReason,
		stopLossPriceStringValue,
		stopLossPercentStringValue,
		stopLossPrice,
		stopLossInvalid,
		stopLossInvalidReason,
		updatePrice,
		updatePercent,
		updateOrders,
		formDisabled,
		triggerOrderDirection,
		baseOrderDirection,
		selectedMarketId,
		isStopLossBeyondLiquidationPrice,
		positionIsLong,
	} = useTpSlOrderForm({
		direction,
		entryPrice,
		entrySize,
		saveOrdersCallback,
		savedTakeProfitPrice,
		savedStopLossPrice,
	});

	return (
		<div className="flex flex-col gap-y-2">
			<TpSlOrderFormInputs
				isTakeProfit
				baseOrderDirection={baseOrderDirection}
				triggerOrderDirection={triggerOrderDirection}
				triggerPrice={takeProfitPrice}
				triggerPriceStringValue={takeProfitPriceStringValue}
				triggerPercentStringValue={takeProfitPercentStringValue}
				updatePrice={updatePrice}
				updatePercent={updatePercent}
				updateOrders={updateOrders}
				entrySize={entrySize}
				entryPrice={entryPrice}
				selectedMarketId={selectedMarketId}
				orderType={orderType}
				disabled={formDisabled}
				invalid={takeProfitInvalid}
			/>
			<TpSlOrderFormInputs
				isTakeProfit={false}
				baseOrderDirection={baseOrderDirection}
				triggerOrderDirection={triggerOrderDirection}
				triggerPrice={stopLossPrice}
				triggerPriceStringValue={stopLossPriceStringValue}
				triggerPercentStringValue={stopLossPercentStringValue}
				updatePrice={updatePrice}
				updatePercent={updatePercent}
				updateOrders={updateOrders}
				entrySize={entrySize}
				entryPrice={entryPrice}
				selectedMarketId={selectedMarketId}
				orderType={orderType}
				disabled={formDisabled}
				invalid={stopLossInvalid}
			/>
			<TpSlOrderFormMessage
				formDisabled={formDisabled}
				takeProfitInvalid={takeProfitInvalid}
				takeProfitInvalidReason={takeProfitInvalidReason}
				stopLossInvalid={stopLossInvalid}
				positionIsLong={positionIsLong}
				isStopLossBeyondLiquidationPrice={isStopLossBeyondLiquidationPrice}
				stopLossInvalidReason={stopLossInvalidReason}
			/>
		</div>
	);
};

export default React.memo(TpSlOrderForm, compareDriftProps);
